import React, { useState } from 'react';
import { CButton } from '@coreui/react';
import ConfirmationDialog from './ConfirmationDialog';
import LoadingButton from './LoadingButton';

export interface ButtonWithConfirmationProps extends CButton {
  isLoading?: boolean;
  loadingLabel?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  dialogTextProps?: {
    title?: string;
    bodyTxt?: string;
    cancelButtonTxt?: string;
    confirmButtonTxt?: string;
  }
}

const ButtonWithConfirmation = (props: ButtonWithConfirmationProps) => {
  const {
    isLoading = false,
    loadingLabel,
    onConfirm = () => {},
    onCancel = () => {},
    dialogTextProps,
    children,
    ...buttonProps
  } = props;

  const [state, setState] = useState(false);

  const clickHandler = () => {
    setState(true);
  };

  const handleConfirm = () => {
    onConfirm();
    setState(false);
  };

  const handleCancel = () => {
    onCancel();
    setState(false);
  };

  return (
    <>
      <LoadingButton
        isLoading={ isLoading }
        loadingLabel={ loadingLabel }
        onClick={clickHandler}
        {...buttonProps}
      >
        { children }
      </LoadingButton>
      <ConfirmationDialog state={state} onConfirm={handleConfirm} onCancel={handleCancel} {...dialogTextProps} />
    </>
  );
};

export default ButtonWithConfirmation;
